import { initDepotsPage, initDeclaration, initLegacyDeclaration, initDeclarationSummary } from "./depots";
import { initHypotheekPage } from "./hypotheek";
import { initSummaryPage, initTerugbetalenPage, initRedemptionQuestions, initEenmaligPage, initVolledigPage } from "./terugbetalen";
import { initPaymentCompletePage } from "./terugbetalen/payment-complete";
import { initPeriodiekTerugbetalenPage, initPeriodiekAddPage } from "./periodiek-terugbetalen";
import { initSDSPage } from "./sds"; 
import { initChangeBankAccountPage } from "./bankaccount"
import { initRenteAanbod, initDocumentsPage, initOvereenkomstPage, initDocumentDownloads } from "./hypotheekaanvraag";
import { initContactPage, initFAQPage } from "./home";
import { initWoningPage, initValuationUploadPage } from "./woning";
import { initDocumentPage } from "./document";
import { initRepaymentRatePage } from "./aflossingspercentageWijzigen";
import {
    initChangePersonalDataStp,
    initChangePersonalDataStpSummary,
    initChangePersonalData,
    initSettingsPage,
    initChangeAccountData
} from "./account";
import {initLoadingStateButtons, initOpenDialog} from "./helpers";
import {initVerduurzamingPage} from "./verduurzaming";
import { initLoginWithAppTokenPage } from "./single-sign-on/loginWithAppToken";
import { initOmzettenPage } from "./omzetten";
import { initRenteherzieningPage, initOndertekendBevestigingPage } from "./renteherziening";
import { initProformaPage } from "./terugbetalen";
import { initCurrentSituationPage, initializeDebtorDetailsIncome } from "./mortgage-check";

// The keys of the object contain the url of the page.
export const pageScripts = {
    "/account/ChangePersonalDataStp": initChangePersonalDataStp,
    "/account/ChangePersonalDataStpSummary": initChangePersonalDataStpSummary,
    "/account/ChangePersonalData": initChangePersonalData,
    "/account/ChangeAccountData": initChangeAccountData,
    "/account/settings": initSettingsPage,
    "/depots": initDepotsPage,
    "/depots/declarationsummary": initDeclarationSummary,
    "/depots/*": () => {
        initLegacyDeclaration();
        initDeclaration();
    }, 
    "/hypotheek": initHypotheekPage,
    "/sds/*": initSDSPage,
    "/home/contact": initContactPage,
    "/home/faq": initFAQPage,
    "/document/*": initDocumentPage,
    "/bankaccount/bankaccountchangeform": initChangeBankAccountPage,
    "/Hypotheekaanvraag/Renteaanbod": initRenteAanbod,
    "/aflossingspercentageWijzigen/*": initRepaymentRatePage,
    "/verduurzamingsaanvraag/*": initVerduurzamingPage,
    "/Hypotheekaanvraag/Documenten": initDocumentsPage,
    "/Hypotheekaanvraag/Overeenkomst": initOvereenkomstPage,
    "/HypotheekaanvraagDocumenten":initDocumentDownloads,
    "/sso/loginwithapptoken": initLoginWithAppTokenPage,
    "/omzetten/*": initOmzettenPage,
    "/woning/*": () => {
        initWoningPage();
        initValuationUploadPage();
    },
    "/*": initLoadingStateButtons,
    "/renteherziening/Ondertekend": initOndertekendBevestigingPage,
    "/renteherziening/*": initRenteherzieningPage,
    "/terugbetalen": initTerugbetalenPage,
    "/terugbetalen/bereken": initEenmaligPage,
    "/terugbetalen/CalculateFullRedemption": initVolledigPage,
    "/terugbetalen/redemptionQuestions": initRedemptionQuestions,
    "/terugbetalen/PaymentComplete": initPaymentCompletePage,
    "/periodiekterugbetalen/*": () => {
        initPeriodiekTerugbetalenPage();
        initPeriodiekAddPage();
    },
    "/terugbetalen/proforma": initProformaPage,
    "/terugbetalen/samenvatting": initSummaryPage,
    "/MortgageCheck/CurrentSituation/*": initCurrentSituationPage,
    "/MortgageCheck/DebtorDetails/*": initializeDebtorDetailsIncome
};